import resolveMfaEnforcementState, { type MfaEnforcementState } from "~/helpers/mfaEnforcement";
import useMultiFactorStatus from "~settings/security/hooks/useMultiFactorStatus";

export interface UseMfaEnforcementStateParams {
	skip?: boolean;
}

export interface UseMfaEnforcementStateReturn {
	graceDeadline: string | null;
	refetch: () => void;
	state: MfaEnforcementState;
}

const useMfaEnforcementState = ({ skip = false }: UseMfaEnforcementStateParams = {}): UseMfaEnforcementStateReturn => {
	const { isError, refetch, status } = useMultiFactorStatus({ skip });
	const graceDeadline = status?.graceDeadline ?? null;

	return {
		graceDeadline,
		refetch,
		state:
			status && !isError
				? resolveMfaEnforcementState({
						graceDeadline,
						mfaEnrollmentBlocking: status.mfaEnrollmentBlocking,
						mfaEnrollmentRequired: status.mfaEnrollmentRequired
					})
				: "none"
	};
};

export default useMfaEnforcementState;
